import { Panel } from "primereact/panel";
import { Tag } from "primereact/tag";
import { useGetEventCancellationQuery } from "../store/services/event-cancellations";
import { formatAffectedInscriptions } from "../models/eventCancellation";
import { formatDateWithoutSeconds } from "../utils/functions/date";

interface EventCancellationDetailsProps {
  eventId: number;
  isEventActive: boolean | undefined;
}

export const EventCancellationDetails = ({
  eventId,
  isEventActive,
}: EventCancellationDetailsProps) => {
  const { data: cancellation } = useGetEventCancellationQuery(eventId, {
    skip: isEventActive !== false || !eventId,
  });

  if (isEventActive !== false || !cancellation) {
    return null;
  }

  return (
    <Panel
      className="mt-4"
      toggleable
      collapsed
      header={`Cancelado el ${formatDateWithoutSeconds(cancellation.cancelledAt)} por ${
        cancellation.cancelledByName
      } — ${cancellation.reasonText}`}
    >
      <div className="grid">
        <div className="col-12 md:col-6">
          <span className="block text-500 text-sm">Fecha y hora</span>
          <span className="font-medium">
            {formatDateWithoutSeconds(cancellation.cancelledAt)}
          </span>
        </div>
        <div className="col-12 md:col-6">
          <span className="block text-500 text-sm">Cancelado por</span>
          <span className="font-medium">
            {cancellation.cancelledByName}
            {cancellation.cancelledByRole ? ` (${cancellation.cancelledByRole})` : ""}
          </span>
        </div>
        <div className="col-12 md:col-6">
          <span className="block text-500 text-sm">Motivo</span>
          <span className="font-medium">{cancellation.reasonText}</span>
        </div>
        <div className="col-12 md:col-6">
          <span className="block text-500 text-sm">Inscriptos afectados</span>
          <span className="font-medium">
            {formatAffectedInscriptions(
              cancellation.affectedUsers,
              cancellation.affectedCompanions
            )}
          </span>
        </div>
        {!!cancellation.internalNote && (
          <div className="col-12">
            <span className="block text-500 text-sm">Observación interna</span>
            <span className="font-medium white-space-pre-line">
              {cancellation.internalNote}
            </span>
          </div>
        )}
        <div className="col-12 md:col-6">
          <span className="block text-500 text-sm">Requiere reembolso</span>
          <Tag
            className="mt-1"
            severity={cancellation.requiresRefund ? "danger" : "secondary"}
            value={cancellation.requiresRefund ? "Sí" : "No"}
          />
        </div>
      </div>
    </Panel>
  );
};
